// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2ExuP","amount":"Amount_amount__3qt24","tip":"Amount_tip__2DiaZ","tipHeader":"Amount_tipHeader__22yGT","tipsWrap":"Amount_tipsWrap__2x2R4"};